import { useCallback, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import NewsFeed from "./components/NewsFeed";
import Columns from "./components/Columns";
import HotRank from "./components/HotRank";
import Crowd from "./components/Crowd";
import TopicZones from "./components/TopicZones";
import Faq from "./components/Faq";
import About from "./components/About";
import Subscribe from "./components/Subscribe";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  const [activeCategory, setActiveCategory] = useState("全部");
  const [query, setQuery] = useState("");

  const scrollToFeed = () => {
    requestAnimationFrame(() => {
      document.getElementById("feed")?.scrollIntoView({ behavior: "smooth" });
    });
  };

  const handleSearch = useCallback(
    (q: string) => {
      setQuery(q);
      setActiveCategory("全部");
      scrollToFeed();
    },
    []
  );

  const handlePickCategory = useCallback(
    (name: string) => {
      setQuery("");
      setActiveCategory(name);
      scrollToFeed();
    },
    []
  );

  return (
    <div className="min-h-screen w-full bg-background-50 text-foreground-950">
      <Navbar />
      <main>
        <Hero onSearch={handleSearch} />
        <NewsFeed activeCategory={activeCategory} onCategoryChange={setActiveCategory} query={query} />
        <Columns onPickCategory={handlePickCategory} />
        <HotRank />
        <Crowd />
        <TopicZones />
        <Faq />
        <About />
        <Subscribe />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}